"use client";

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";

/**
 * Client-only Sonner mount. Root layout is a Server Component and cannot use
 * `next/dynamic(..., { ssr: false })` directly — keep the toaster off the
 * marketing critical path via this thin wrapper.
 */
const Toaster = dynamic(
  () => import("@/components/ui/sonner").then((m) => m.Toaster),
  { ssr: false },
);

type ToasterProps = ComponentProps<
  typeof import("@/components/ui/sonner").Toaster
>;

export function LazyToaster(props: ToasterProps) {
  return <Toaster {...props} />;
}
